import type {ReactElement} from 'react';
import React from 'react';
import type {StaticDotProps} from './static-dot.types';
import styles from './static-dot.module.scss';

export function StaticDot({size, theme, containerClassname = ''}: StaticDotProps): ReactElement {
  return (
    <div className={`flex-center ${styles.container} ${styles[size]} ${styles[theme]} ${containerClassname}`}>
      <div className={`radius-round ${styles.outerRing}`}></div>
      <div className={`radius-round ${styles.innerDot}`} />
    </div>
  );
}
